import { useOutletContext } from 'react-router-dom';
import { KnowledgeManager } from '@/components/admin/knowledge/KnowledgeManager';

export default function AdminKnowledge() {
  const { orgId } = useOutletContext<{ orgId: string }>();

  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <h2 className="text-2xl font-heading font-semibold">Knowledge</h2>
        <p className="text-sm text-muted-foreground">
          Give Ask the context it cannot infer from the data. Strategy, values, operating model,
          restructures, anything that explains why your numbers look the way they do. Documents
          stay inside this organisation and are never shared with another tenant.
        </p>
      </div>

      <KnowledgeManager
        scope="org"
        orgId={orgId}
        title="Your organisation's documents"
        description="Retrieved whenever Ask writes recommendations for this organisation."
      />
    </div>
  );
}
